import { Fragment, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import Layout from '../components/Layout';
import NamingPage from '../pages/naming';
import NotFoundPage from '../pages/notFound';
import PartiallyPaid from '../pages/partially-paid';
import PaymentPage from '../pages/payment';
import PaymentConfirmed from '../pages/payment-confirmed';
import PaymentInProcess from '../pages/payment-in-process';
import TicketsPage from '../pages/tickets';

const FIXED_PATH = ':clientUrl/event/:eventId/';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.IngresseCheckout) {
      window.IngresseCheckout.trackPageView();
    }
  }, [location]);

  return  null;
};

const RoutesApp = () => {
  return (
    <BrowserRouter>
      <RouteChangeTracker />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path={`/sso/${FIXED_PATH}`} element={<Fragment />} />
          <Route path={`/tickets/${FIXED_PATH}`} element={<TicketsPage />} />
          <Route path={`/naming/${FIXED_PATH}`} element={<NamingPage />} />
          <Route path={`/payment/${FIXED_PATH}`} element={<PaymentPage />} />
          <Route
            path={`/payment-confirmed/${FIXED_PATH}`}
            element={<PaymentConfirmed />}
          />
          <Route
            path={`/payment-in-process/${FIXED_PATH}`}
            element={<PaymentInProcess />}
          />
          <Route
            path={`/partially-paid/${FIXED_PATH}`}
            element={<PartiallyPaid />}
          />

          <Route path="/*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesApp;

